import { MapPin, Video, Home, Users } from "lucide-react";
import { Reveal, ContactLinks } from "../components/shared";
import { SiteLayout, PageHero, BookBtn, ReferBtn, Caps } from "../components/site";
import { CONTACT, HOURS } from "../content";
import { EnquiryBtn } from "../components/enquiry";

const MODES = [
  { icon: MapPin, title: "In clinic", text: "Upper Mount Gravatt, Brisbane Southside" },
  { icon: Video, title: "Telehealth", text: "Available Australia-wide" },
  { icon: Home, title: "Home visits", text: "Available with selected practitioners" },
  { icon: Users, title: "Outreach", text: "Support in community settings" },
];

export default function Contact() {
  return (
    <SiteLayout testid="contact-page">
      <PageHero eyebrow="Contact" lines={["Thanks for reaching out.", "We're here to help."]} sub="Call, email, book or enquire. We'll point you in the right direction.">
        <BookBtn testid="contact-book" /><EnquiryBtn testid="contact-enquiry" /><ReferBtn testid="contact-refer" />
      </PageHero>
      <section className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="service-modes">
        {MODES.map((m, i) => (
          <Reveal key={m.title} delay={i * 0.08} className="rounded-[28px] bg-[#DCE6EC] odd:bg-[#E3E9E4] p-7">
            <m.icon className="w-7 h-7 text-[#3F4A3C]" strokeWidth={1.3} />
            <h3 className="mt-6 font-newsreader text-2xl text-[#3F4A3C]">{m.title}</h3>
            <p className="mt-2 font-jakarta text-sm text-[#4A4F45]">{m.text}</p>
          </Reveal>
        ))}
      </section>
      <section className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-24 grid lg:grid-cols-2 gap-8">
        <Reveal className="rounded-[28px] bg-[#F9F6EF] border border-[#3F4A3C]/10 p-8 sm:p-10">
          <Caps>Clinic</Caps>
          <p className="mt-4 font-newsreader text-3xl text-[#3F4A3C]">{CONTACT.address}</p>
          <ContactLinks prefix="contact" className="mt-6 flex flex-col gap-3 font-jakarta text-[#3F4A3C]" linkClass="hover:underline underline-offset-4" />
          <ul className="mt-8 border-t border-[#3F4A3C]/15" data-testid="hours-list">
            {HOURS.map((h) => <li key={h.day} className="flex justify-between gap-4 py-4 border-b border-[#3F4A3C]/15 font-jakarta text-sm"><span>{h.day}</span><span className="text-[#3F4A3C] font-medium text-right">{h.time}</span></li>)}
          </ul>
        </Reveal>
        <Reveal delay={0.1} className="flex flex-col gap-8">
          <div className="rounded-[30px] bg-[#F6F2E9] p-2.5 sm:p-3 ring-1 ring-[#C59B45]/50 shadow-[0_30px_60px_-35px_rgba(15,90,68,0.45)]"><div className="aspect-[3/2] overflow-hidden rounded-[22px]"><img src="/images/practice-room.jpg" alt="A calm therapy room at Inner You Development with a green sofa, plants and soft lighting" loading="lazy" data-testid="contact-practice-photo" className="w-full h-full object-cover" /></div></div>
          <div className="rounded-[28px] overflow-hidden min-h-[360px] bg-[#E3E9E4]">
          <iframe title="Map to Inner You Development" data-testid="contact-map" loading="lazy" className="w-full h-full min-h-[360px] border-0" src={`https://www.google.com/maps?q=${encodeURIComponent("2092 Logan Rd, Upper Mount Gravatt QLD 4122")}&output=embed`} />
          </div>
        </Reveal>
      </section>
      <div className="pb-24" />
    </SiteLayout>
  );
}
